import { getLastLoginHostname } from 'plugin/src/tools/getLastLoginHostname'
import { useGenericRequestHandler } from '../../handlers/useGenericRequestHandler'

export const useCanInsertAudioIntoSlidesMutation = () => {
  const json = {
    containingURL: window.location.href,
    lastLoginHost: getLastLoginHostname()
  }

  return useGenericRequestHandler({
    route: 'm/canInsertAudioIntoSlides',
    method: 'POST',
    options: {
      json
    }
  })
}
